import axios from 'axios';
import swal from "sweetalert";
import {
    loginConfirmedAction,
    Logout,
    updateSelectedLoginData,
    updateUserData,
} from '../store/actions/AuthActions';
import nbrApi from './nbrApi';
import { crypt } from './common.utils';

export function signUp(email, password) {
    //axios call
    const postData = {
        email,
        password,
        returnSecureToken: true,
    };
    return axios.post(
        `https://identitytoolkit.googleapis.com/v1/accounts:signUp?key=AIzaSyD3RPAp3nuETDn9OQimqn_YF6zdzqWITII`,
        postData,
    );
}

export function login(email, password) {
    const postData = {
        email_address : email,
        pwd : password,
        login_function: "login", // Add login_function parameter
        // returnSecureToken: true,
    };
    
    return nbrApi.post('/login', postData);
}

export function requestPasswordReset(email) {
    return nbrApi.post('/forgotpassword', { email_address: email });
}

export function verifyPasswordOtp({ email, otp }) {
    return nbrApi.post('/verifyotp', { email_address: email, otp_val: otp });
}

export function resetPassword({ email, password, confirmPassword }) {
    return nbrApi.post('/resetpassword', {
        email_address: email,
        new_password: password,
        confirm_password: confirmPassword,
    });
}

export function formatError(errorResponse) {
    switch (errorResponse.error.message) {
        case 'EMAIL_EXISTS':
            //return 'Email already exists';
            swal("Oops", "Email already exists", "error");
            break;
        case 'EMAIL_NOT_FOUND':
            //return 'Email not found';
            swal("Oops", "Email not found", "error", { button: "Try Again!", });
            break;
        case 'INVALID_PASSWORD':
            //return 'Invalid Password';
            swal("Oops", "Invalid Password", "error", { button: "Try Again!", });
            break;
        case 'USER_DISABLED':
            return 'User Disabled';

        default:
            return '';
    }
}

export function saveTokenInLocalStorage(tokenDetails) {
    // console.log(tokenDetails)
    tokenDetails.expireDate = new Date(
        new Date().getTime() + tokenDetails.expiresIn * 1000,
    );
    localStorage.setItem('userDetails', JSON.stringify(tokenDetails));
}

export function runLogoutTimer(dispatch, timer, navigate) {
    setTimeout(() => {
        // dispatch(Logout(history));
        dispatch(Logout(navigate));
    }, timer);
}

// export function checkAutoLogin(dispatch, navigate) {
//     const tokenDetailsString = localStorage.getItem('userDetails') ? JSON.parse(localStorage.getItem('userDetails')) : [];
//     let tokenDetails = '';
//     if (tokenDetailsString?.length === 0) {
//         dispatch(Logout(navigate));
//         return;
//     }

//     tokenDetails = tokenDetailsString[0];
//     // let expireDate = new Date(tokenDetails.expireDate);
//     // let todaysDate = new Date();

//     // if (todaysDate > expireDate) {
//     //     dispatch(Logout(navigate));
//     //     return;
//     // }
//     let staticData = {
//         "localId": crypt(tokenDetails?.resources_id),
//         "displayName": tokenDetails?.resource_first + ' ' + tokenDetails?.resource_last,
//         "idToken": crypt(tokenDetails?.resources_id),
//         "registered": true,
//         "refreshToken": crypt(tokenDetails?.resources_id),
//     }
//     dispatch(loginConfirmedAction(staticData));

//     // const timer = expireDate.getTime() - todaysDate.getTime();
//     // runLogoutTimer(dispatch, timer, navigate);
// }
export function checkAutoLogin(dispatch, navigate) {
    const tokenDetailsString = localStorage.getItem('userDetails');
    let tokenDetails = '';
    if (!tokenDetailsString) {
        const publicAuthPaths = [
            '/login',
            '/page-register',
            '/page-forgot-password',
            '/forgot-password',
            '/page-reset-password',
            '/reset-password',
        ];
        if (!publicAuthPaths.includes(window.location.pathname)) {
            dispatch(Logout(navigate));
        }
        return;
    }

    tokenDetails = JSON.parse(tokenDetailsString);
    dispatch(updateUserData(tokenDetails))

    // let expireDate = new Date(tokenDetails.expireDate);
    // let todaysDate = new Date();

    // if (todaysDate > expireDate) {
    //     dispatch(Logout(navigate));
    //     return;
    // }
    let selectedLoginData = JSON.parse(localStorage?.getItem('selectedLoginData')) || {}
    let properties_id = selectedLoginData?.properties_id
    let role_id = selectedLoginData?.role_id
    let myData = tokenDetails?.filter(e=>  parseInt(e?.properties_id) === parseInt(properties_id) && parseInt(e?.roles_id) === parseInt(role_id))?.[0] || {}
    // console.log(myData)
    let staticData = {
        "localId": crypt(myData?.resources_id),
        "displayName": myData?.resource_first + ' ' + myData?.resource_last,
        "idToken": crypt(myData?.resources_id),
        "registered": true,
        "refreshToken": crypt(myData?.resources_id),
    }
    dispatch(loginConfirmedAction(staticData));
    // let selectedLoginData = localStorage.getItem('selectedLoginData') || {}
    dispatch(updateSelectedLoginData(selectedLoginData))

    // const timer = expireDate.getTime() - todaysDate.getTime();
    // runLogoutTimer(dispatch, timer, navigate);
    // }

}